<!--  -->
<template>
    <el-dialog class="route-plan-modal"
               :title="type + '配置'"
               :visible="dialogVisible"
               @close="resetForm"
               width="1000px">
        <div class="steps">
            <el-steps :active="stepsActive"
                      finish-status="success"
                      align-center>
                <el-step title="线路选择"></el-step>
                <el-step title="新增路由"></el-step>
            </el-steps>
        </div>
        <add-route :lineData="lineDisposeFormData"
                   :editData="editRouteData"
                   :type="type"
                   ref="addRouteRef">
        </add-route>
        <div slot="footer">
            <el-button @click="resetForm">取消</el-button>
            <el-button type="primary"
                       v-show="stepsActive === 0"
                       @click="nextStep">
                下一步
            </el-button>
            <el-button type="primary"
                       v-show="stepsActive === 1 && type==='新增'"
                       @click="backStep">
                上一步
            </el-button>
            <el-button type="primary"
                       v-show="stepsActive === 1"
                       @click="submitReview"
                       :loading="submitLoading">
                保存
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import dayjs from 'dayjs';
import {
    getRouteUpdate,
    getRouteQuery
} from '../../../../api/operationManagementRoutePlan.js';
export default {
    components: {
        AddRoute: () => import('./addRoute.vue')
    },
    data () {
        return {
            dialogVisible: false,
            type: '新增',
            stepsActive: 1,
            submitLoading: false,
            lineDisposeFormData: {},
            editRouteData: {},
            editId: ''
        };
    },
    watch: {
        editId (val) {
            this.stepsActive = 1;
            this.detailDataFn(val);
        }
    },
    methods: {
        resetForm () {
            this.dialogVisible = false;
        },
        // 下一步
        async nextStep () {
            const { tableLineData } = this.$refs.lineSelectRef;
            const { validate } = this.$refs.lineSelectRef.$refs.formRef;
            await validate();
            this.lineDisposeFormData = tableLineData[0];
            this.stepsActive = 1;
        },
        // 上一步
        backStep () {
            this.stepsActive = 0;
        },
        // 保存
        async submitReview () {
            const { editableTabs } = this.$refs.addRouteRef;
            const { validate } = this.$refs.addRouteRef.$refs.formRef[0];
            const { handleRouteData } = this.$refs.addRouteRef;
            await validate();
            if (!handleRouteData()) return;
            const arr = [];
            editableTabs.forEach(e => {
                if (e.routeScheduleList.recommendFlag) {
                    e.routeScheduleList.recommendFlag = e.routeScheduleList.recommendFlag === '1';
                }
                e.routeScheduleList.activeTime = dayjs(new Date(e.routeScheduleList.activeTime).getTime()).format('YYYY-MM-DD') + ' 00:00:00';
                e.routeScheduleList.lineName = this.editRouteData.lineName;
                e.routeScheduleList.lineCode = this.editRouteData.lineCode;
                arr.push(e.routeScheduleList);
            });
            this.submitLoading = true;
            arr.id = this.editRouteData.id;
            await getRouteUpdate(arr[0]).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('修改成功');
                    this.dialogVisible = false;
                    this.$emit('uploadTableList', res.data);
                }
            }).finally(() => {
                this.submitLoading = false;
            });
        },
        // 重置
        clearValidateFn () {
            this.$nextTick(() => {
                this.$refs.lineSelectRef.$refs.formRef.resetFields();
            });
        },
        // 回显
        detailDataFn (id) {
            getRouteQuery({ id }).then(res => {
                this.editRouteData = res.data;
            });
        }
    },
    created () {

    },
    mounted () {

    }
};
</script>
<style lang='less'>
// .route-plan-modal {
//     /deep/ .el-dialog__body {
//         height: 600px;
//     }
// }
.el-form-item__content .el-input-group {
    vertical-align: middle;
}
</style>
